<template>
  <div>
    <p class="right-title">外观设置</p>
    <el-row align="middle" class="option-line-view" type="flex">
      <el-col :span="8">
        <span class="option-line-title">添加logo</span>
      </el-col>
      <el-col :offset="8" :span="8">
        <el-switch v-model="showSettings.logoSetting" @change="cleanFormSave('logoImg')" />
      </el-col>
    </el-row>
    <el-row v-if="showSettings.logoSetting" align="middle" type="flex">
      <el-col :span="6">
        <span class="option-line-sub-title">logo设置</span>
      </el-col>
      <el-col :span="4">
        <img v-if="userFormTheme.logoImg" :src="userFormTheme.logoImg" style="width: 30px; height: 30px" />
      </el-col>
      <el-col :offset="6" :span="8">
        <upload-img :show-file-list="false" listType="text" :limitCount="100" @uploadSuccess="uploadLogoHandle">
          <template slot="btn">
            <el-button slot="trigger" size="small" type="text"> 上传Logo </el-button>
          </template>
        </upload-img>
      </el-col>
    </el-row>
    <el-row v-if="showSettings.logoSetting" align="middle" type="flex">
      <el-col :span="6">
        <span class="option-line-sub-title">logo位置</span>
      </el-col>
      <el-col :span="18">
        <el-radio-group v-model="userFormTheme.logoPosition" size="mini" @change="saveUserTheme" v-removeAriaHidden>
          <el-radio-button label="left"> 左对齐 </el-radio-button>
          <el-radio-button label="center"> 居中 </el-radio-button>
          <el-radio-button label="right"> 右对齐 </el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row align="middle" class="option-line-view" type="flex">
      <el-col :span="8">
        <span class="option-line-title">头图设置</span>
      </el-col>
      <el-col :offset="8" :span="8">
        <el-switch v-model="showSettings.headImgSetting" @change="() => cleanFormSave('headImgUrl')" />
      </el-col>
    </el-row>
    <el-row v-if="showSettings.headImgSetting" align="middle" type="flex">
      <el-col :span="6">
        <span class="option-line-sub-title">上传图片</span>
      </el-col>
      <el-col :span="4">
        <img v-if="userFormTheme.headImgUrl" :src="userFormTheme.headImgUrl" style="width: 30px; height: 30px" />
      </el-col>
      <el-col :offset="6" :span="8">
        <upload-img :show-file-list="false" listType="text" :limitCount="100" @uploadSuccess="uploadHeadImgHandle">
          <template slot="btn">
            <el-button slot="trigger" size="small" type="text"> 上传 </el-button>
          </template>
        </upload-img>
      </el-col>
    </el-row>

    <el-row align="middle" class="option-line-view" type="flex">
      <el-col :span="8">
        <span class="option-line-title">背景设置</span>
      </el-col>
      <el-col :offset="8" :span="8">
        <el-switch v-model="showSettings.backgroundSetting" @change="backgroundChange" />
      </el-col>
    </el-row>
    <el-row v-if="showSettings.backgroundSetting">
      <el-row align="middle" type="flex">
        <el-col :span="8">
          <span class="option-line-sub-title">背景类型</span>
        </el-col>
        <el-col :span="18">
          <el-radio-group v-model="showSettings.backgroundType" size="mini" v-removeAriaHidden>
            <el-radio-button label="color"> 颜色 </el-radio-button>
            <el-radio-button label="img"> 图片 </el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
    </el-row>
    <el-row v-if="showSettings.backgroundSetting && showSettings.backgroundType == 'color'">
      <el-row align="middle" type="flex">
        <el-col :span="8">
          <span class="option-line-sub-title">选择颜色</span>
        </el-col>
        <el-col :span="18">
          <el-color-picker v-model="userFormTheme.backgroundColor" size="mini" @change="handleChangeColor" />
        </el-col>
      </el-row>
    </el-row>
    <el-row v-if="showSettings.backgroundType == 'img'">
      <el-row align="middle" type="flex">
        <el-col :span="8">
          <span class="option-line-sub-title">选择图片</span>
        </el-col>
        <el-col :offset="8" :span="8">
          <upload-img :show-file-list="false" listType="text" :limitCount="100" @uploadSuccess="uploadBackgroundHandle">
            <template slot="btn">
              <el-button slot="trigger" size="small" type="text"> 上传背景 </el-button>
            </template>
          </upload-img>
        </el-col>
      </el-row>
    </el-row>
    <el-row align="middle" class="option-line-view" type="flex">
      <el-col :span="8">
        <span class="option-line-title">按钮设置</span>
      </el-col>
      <el-col :offset="8" :span="8">
        <el-switch v-model="showSettings.btnSetting" />
      </el-col>
    </el-row>
    <el-row v-if="showSettings.btnSetting">
      <!-- <el-row align="middle" type="flex">
          <el-col :span="12">
            <span class="option-line-sub-title">显示提交按钮</span>
          </el-col>
          <el-col :span="10">
            <el-switch v-model="userFormTheme.showSubmitBtn" @change="saveUserTheme" />
          </el-col>
        </el-row> -->
      <el-row align="middle" type="flex">
        <el-col :span="12">
          <span class="option-line-sub-title">按钮提示文字</span>
        </el-col>
        <el-col :span="10">
          <el-input
            v-model="userFormTheme.submitBtnText"
            placeholder="请输入内容"
            size="mini"
            style="width: 80%"
            @change="saveUserTheme"
          />
        </el-col>
      </el-row>
    </el-row>
    <el-row align="middle" class="option-line-view" type="flex">
      <el-col :span="8">
        <span class="option-line-title">显示标题</span>
      </el-col>
      <el-col :offset="8" :span="8">
        <el-switch v-model="userFormTheme.showTitle" @change="saveUserTheme" />
      </el-col>
    </el-row>
    <el-row align="middle" class="option-line-view" type="flex">
      <el-col :span="8">
        <span class="option-line-title">显示描述</span>
      </el-col>
      <el-col :offset="8" :span="8">
        <el-switch v-model="userFormTheme.showDescribe" @change="saveUserTheme" />
      </el-col>
    </el-row>
    <el-row align="middle" class="option-line-view" type="flex">
      <el-col :span="8">
        <span class="option-line-title">显示题号</span>
      </el-col>
      <el-col :offset="8" :span="8">
        <el-switch v-model="userFormTheme.isShowItemQuestionNumber" @change="saveUserTheme" />
      </el-col>
    </el-row>
    <el-row v-if="userFormTheme.isShowItemQuestionNumber" align="middle" class="option-line-view" type="flex">
      <el-col :span="13">
        <span class="option-line-title">题号按顺序显示</span>
        <el-tooltip class="item" effect="dark" content="开启后，题号按自增序号显示如：1、2、3、4、5…" placement="top">
          <i class="el-icon-question" style="margin-left: 4px"></i>
        </el-tooltip>
      </el-col>
      <el-col :offset="3" :span="8">
        <el-switch v-model="userFormTheme.showNumber" @change="saveUserTheme" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUserThemeRequest, saveUserThemeRequest } from '@/api/project/form'
import UploadImg from '@/components/Upload/UploadImg.vue'

export default {
  name: 'UserTheme',
  props: ['formKey'],
  components: { UploadImg },
  data() {
    return {
      // 外观设置
      showSettings: {
        logoSetting: false, // 打开logo
        headImgSetting: false, // 打开logo
        backgroundSetting: false,
        btnSetting: true,
        backgroundType: 'color'
      },
      // 用户主题设置
      userFormTheme: {
        formKey: '',
        themeId: '',
        showTitle: true,
        showDescribe: true,
        showNumber: true, // 显示问题行号
        isShowItemQuestionNumber: false, // 是否展示问题题号
        backgroundColor: '',
        backgroundImg: '',
        headImgUrl: '',
        logoImg: '',
        logoPosition: 'left',
        showSubmitBtn: true,
        submitBtnText: '提交'
      }
    }
  },
  mounted() {
    this.queryUserFormTheme()
  },
  methods: {
    backgroundChange() {
      this.userFormTheme.backgroundImg = ''
      this.userFormTheme.backgroundColor = ''
      this.saveUserTheme()
    },
    uploadBackgroundHandle(response) {
      this.userFormTheme.backgroundImg = response[response.length - 1].url
      this.userFormTheme.backgroundColor = ''
      this.saveUserTheme()
    },
    uploadLogoHandle(response) {
      console.log({ response })
      this.userFormTheme.logoImg = response[response.length - 1].url
      this.saveUserTheme()
    },
    uploadHeadImgHandle(response) {
      this.userFormTheme.headImgUrl = response[response.length - 1].url
      this.saveUserTheme()
    },
    handleChangeColor(val) {
      console.log({ val })
      if (!val) this.userFormTheme.backgroundColor = ''
      this.saveUserTheme()
    },
    activeStyleHandle(item) {
      this.activeStyle = item.key
      this.queryFormTheme()
    },
    cleanFormSave(key) {
      this.userFormTheme[key] = ''
      this.saveUserTheme()
    },
    saveUserTheme(item) {
      console.log(item)
      const { formKey, showSettings } = this
      this.userFormTheme.formKey = formKey
      if (showSettings.backgroundType == 'img') {
        this.userFormTheme.backgroundColor = ''
      } else {
        this.userFormTheme.backgroundImg = ''
      }
      // 如果不显示题号，那么序号开关还原
      if (!this.userFormTheme.isShowItemQuestionNumber) {
        this.userFormTheme.showNumber = true
      }

      saveUserThemeRequest(this.userFormTheme).then(() => {
        this.$emit('handleChangeFormKey')
      })
    },
    queryUserFormTheme(data) {
      console.log({ ss: this.formKey })
      if (!data) {
        return
      }
      this.userFormTheme = data
      let { themeId, logoImg, backgroundImg, headImgUrl, backgroundColor, submitBtnText } = data
      this.activeTheme = {
        id: themeId
      }
      this.showSettings.logoSetting = !!logoImg
      this.showSettings.headImgSetting = !!headImgUrl
      this.showSettings.btnSetting = !!submitBtnText
      if (backgroundImg || backgroundColor) {
        this.showSettings.backgroundSetting = true
        this.showSettings.backgroundType = backgroundImg ? 'img' : 'color'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.file-list-wrapper {
  width: 95%;
}

.option-line-view {
  padding: 0;
  width: 280px;
  height: 42px;
  line-height: 20px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 10px;
  border: 1px solid rgb(231, 229, 229);
}
.option-line-title {
  color: rgba(16, 16, 16, 100);
  line-height: 40px;
  font-size: 14px;
  text-align: left;
}
.option-line-sub-title {
  color: rgb(82, 81, 81);
  line-height: 50px;
  font-size: 14px;
  text-align: left;
}
</style>
